// extracted by mini-css-extract-plugin
export var caption = "newsletter-social-module--caption--08c41";
export var post = "newsletter-social-module--post--0b012";
export var spin = "newsletter-social-module--spin--e48bd";